import { Column, Icon, Row, Text } from "@amzn/meridian";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "src/store/store";
import chevronLeftLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-left-large";
import { getInspectionWorkflow } from "src/store/workflowSlice";
import { useAppDispatch } from "src/store/store";
import WorkflowCard from "./workflowCard";
import "./configurationDrivenInspections.scss";

const ConfigurationDrivenInspections = () => {
  const { workflows } = useAppSelector((state) => state.workflow);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getInspectionWorkflow());
  }, []);

  return (
    <Column
      className="configdriven-page pwa-scrollable"
      spacingInset="500"
      spacing="400"
    >
      <Row alignmentVertical="center" spacing="300">
        <div
          onClick={() => navigate("/")}
          role="button"
        >
          <Icon tokens={chevronLeftLargeTokens} color="primary" />
        </div>
        <Text type="b300" color="primary">
          Dashboard
        </Text>
      </Row>
      <Column>
        <Text type="h300" color="primary">
          Choose inspection
        </Text>
        {workflows.length > 0 ?
          workflows.map((wf) => (
            <WorkflowCard key={wf.template_id} workflow={wf} />
          )) :
          <Text type="h100">
            There are no available inspection templates at the moment.
          </Text>}
      </Column>
    </Column>
  );
};

export default ConfigurationDrivenInspections;
